<mcg-window #pluginsWindow
  [width]="310" [height]="100" [canResize]="false" [title]="translate('Exportar_tabla')">
  <div class="dialog-content">
    <div class="export-title">
      <p>{{translate("Como_exportar")}}</p>
    </div>

    @if(isGoogleDriveEnabled()) {
      <div class="export-buttons">
        <button (click)="actionButtonClicked({ action: 'google-drive' })">
          {{translate("Exportar_drive_boton")}}
        </button>
        <button (click)="actionButtonClicked({ action: 'download' })">
          {{translate("Descargar_archivo")}}
        </button>
      </div>
    }

  </div>
</mcg-window>
